import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";

import './i18n'; // <-- Add this line to import your i18n configuration

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);